module.exports = __webpack_public_path__ + "img/logo.b541a974.png";